import React, { useState, useEffect } from 'react';

import axios from 'axios';
import Header from "../Components/Header";
import Chart from 'react-apexcharts';
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
ReactSession.setStoreType("localStorage");



const Dashboard = () => {
  const userId=ReactSession.get("welbeingId");
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({});
  const [orderdata, setOrderdata] = useState({});
  const [loading, setLoading] = useState(true);

  if(userId  <= 0 ){
      navigate('/login');
   }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dashboardResponse = await axios.get('https://api.welbeing.in/admin/report/');
  
        setDashboardData(dashboardResponse.data.data);
        const ordersResponse = await axios.get('https://api.welbeing.in/admin/order/recent-order/');
        setOrderdata(ordersResponse.data.data)
    
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

// //   const handlePaymentModeChange = async (mode) => {
// //     try {
// //       await axios.post('/api/payment-mode', { mode });
// //       setDashboardData(prev => ({ ...prev, paymentMode: mode }));
// //     } catch (error) {
// //       console.error('Error updating payment mode:', error);
// //     }
//   };

const chartOptions = {
  chart: { type: 'donut' },
  labels: ['Available', 'Sold'],
    legend: {
    show: false
  },
  responsive: [
    {
      breakpoint: 180,
      options: {
        chart: { width: 150 },
        legend: { show: false }
      }
    }
  ]
};

  const chartSeries = [dashboardData.customer, dashboardData.products];

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  return (
   <>
      <Header />
       <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="body-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div class="col-lg-7 d-flex align-items-stretch">
                <div class="card w-100 bg-light-info overflow-hidden shadow-none">
                  <div class="card-body position-relative">
                    <div class="row">
                      <div class="col-sm-8 col-12 mb-3 mb-sm-0">
                        <div class="d-flex align-items-center mb-3">
                          <div class="rounded-circle overflow-hidden me-6">
                            <img src="dist/images/profile/user-1.jpg" alt="" width="40" height="40" />
                          </div>
                          <h5 class="fw-semibold mb-0 fs-5">Welcome back Admin!</h5>
                        </div>
                        <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                          <div class="mb-3 mb-sm-0 pe-sm-4 border-end border-muted border-opacity-10">
                            <h3 class="mb-1 fw-semibold fs-6">{dashboardData.sales}</h3>
                            <p class="mb-0 text-dark">Today’s Sales</p>
                          </div>
                          <div class="mb-3 mb-sm-0 ps-sm-4">
                            <h3 class="mb-1 fw-semibold fs-6">{dashboardData.todayPerformance}%</h3>
                            <p class="mb-0 text-dark">Today's Performance</p>
                          </div>
                          <div class="mb-3 mb-sm-0 ps-sm-4">
                            <h3 class="mb-1 fw-semibold fs-6">{dashboardData.thisMonthPerformance}%</h3>
                            <p class="mb-0 text-dark">This Month's Performance</p>
                          </div>
                          <div class="ps-sm-4">
                            <h3 class="mb-1 fw-semibold fs-6">{dashboardData.lastMonthPerformance}%</h3>
                            <p class="mb-0 text-dark">Last Month's Performance</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="welcome-bg-img mb-n7 float-right text-end">
                          <img src="https://demos.adminmart.com/premium/bootstrap/modernize-bootstrap/package/dist/images/backgrounds/welcome-bg.svg" alt="" class="img-fluid" style={{ marginLeft: '10px' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-2 d-flex align-items-stretch">
                <div className="card w-100">
                  <div className="card-body p-4">
                    <h4 className="fw-semibold">{dashboardData.products}</h4>
                    <p className="mb-2 fs-3">Products</p>
                    <Chart options={chartOptions} series={chartSeries} type="donut" height={150} />
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 d-flex align-items-stretch">
                <div className="card w-100">
                  <div className="card-body p-4">
                    <h4 className="fw-semibold">{dashboardData.customer}</h4>
                    <p className="mb-1 fs-3">Customers</p>
                    <div id="sales" className="sales-chart"></div>
                    <h6 className="fw-semibold mt-4 mb-2">Payment Gateway</h6>
                    <div className="btn-group">
                      <button className="btn btn-primary">Razorpay</button>
                      {/* {dashboardData.paymentMode === 'ccavenue' ? (
                  <>
                    <button 
                      className="btn btn-light-primary" 
                      onClick={() => handlePaymentModeChange('razorpay')}
                    >
                      Razorpay
                    </button>
                    <button className="btn btn-primary">CCAvenue</button>
                  </>
                ) : (
                  <>
                    <button className="btn btn-primary">Razorpay</button>
                    <button 
                      className="btn btn-light-primary" 
                      onClick={() => handlePaymentModeChange('ccavenue')}
                    >
                      CCAvenue
                    </button>
                  </>
                )} */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                      <h5>Recent Orders</h5>
                      <table className="table border table-striped table-bordered display overflow-visible" style={{ minWidth: '900px' }}>
                        <thead>
                          <tr>
                            <th>Customer</th>
                            <th>Date</th>
                            <th>Order From</th>
                            <th>Order ID</th>
                            <th>Items</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderdata.map((order) => (
                            <tr key={order.order_id}>
                              <td>
                                <div className="d-flex align-items-center">
                                  {/* <img src={order.img || '/customer_data/no_image.webp'} className="rounded-circle" width="40" height="40" alt="Customer" /> */}
                                  <div className="ms-3">
                                    <h6 className="mb-0">{order.name}</h6>
                                  </div>
                                </div>
                              </td>
                              <td>{order.order_time}</td>
                              <td>{order.order_from}</td>
                              <td>{order.order_id}</td>
                              <td>{order.count}</td>
                              <td>{order.status}</td>
                              <td className='text-end'>₹ {Number(order.grand_total).toFixed(2)}</td>
                              <td align="right">
                                <div className="btn-group">
                                  <a className="btn btn-success bg-gradient-success" href={`/orderdetails?id=${order.order_id}`}><i className="ti ti-eye"></i></a>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;